import { useRoute } from "@react-navigation/native";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import React from "react";
import { useApi } from "../../../core/apis";
import { useStores } from "../../../core/stores";

export const useBusinessTeamSection = () => {
  const route =
    useRoute<
      NativeStackScreenProps<
        ReactNavigation.RootParamList,
        "BusinessHome"
      >["route"]
    >();
  const { businessPlansStore, plansStore, sectionsStore, modulesStore } =
    useStores();
  const { sectionsApi, modulesApi } = useApi();

  const businessPlan = businessPlansStore.byId.get(route.params.businessUid);
  const planId = businessPlan?.userInPlan?.data.planUid;

  const plan = planId ? plansStore.byId.get(planId) : undefined;

  const planQuickstartSectionUid = plan?.data.sectionIds[1];
  const section = sectionsStore.byId.get(planQuickstartSectionUid ?? "");

  React.useEffect(() => {
    if (planQuickstartSectionUid) {
      const unsub = sectionsApi.watchItem(planQuickstartSectionUid);
      return () => {
        unsub();
      };
    }
  }, [sectionsApi, planQuickstartSectionUid]);

  React.useEffect(() => {
    if (section?.data.moduleIds.length) {
      // make sure to load all modules once
      section.data.moduleIds.forEach((moduleUid) => {
        if (!modulesStore.byId.get(moduleUid)) {
          void modulesApi.getById(moduleUid);
        }
      });
    }
  }, [section?.data.moduleIds, modulesApi, modulesStore]);

  return section;
};
